import { IconButton } from '@mui/material'
import { MdCheckCircle } from 'react-icons/md'

const IconeQuestionarioTermo = ({
  icon: Icon,
  titulo,
  status,
  codigo,
  onClick,
}) => {
  const renderStatus = () => {
    if (status === true && codigo !== null) {
      return (
        <MdCheckCircle
          style={{
            position: 'absolute',
            bottom: 0,
            right: 0,
            fontSize: 12,
            color: 'green',
          }}
        />
      )
    }
    return null
  }

  return (
    <div style={{ textAlign: 'center' }}>
      <div style={{ position: 'relative', display: 'inline-block' }}>
        <IconButton
          onClick={onClick}
          disabled={status === false || codigo === null}
          style={{ cursor: codigo !== null ? 'pointer' : 'not-allowed' }}
        >
          <Icon
            size={25}
            color={
              status === false
                ? '#b2b2b2'
                : Number.isInteger(codigo)
                  ? '#2e7d32'
                  : '#ff3b3b'
            }
          />
        </IconButton>
        {renderStatus()}
      </div>
      <div style={{ fontSize: 8 }}>{titulo}</div>
    </div>
  )
}

export default IconeQuestionarioTermo
